import { render, staticRenderFns } from "./PpnKeluaran.vue?vue&type=template&id=4035bc3f"
import script from "./PpnKeluaran.vue?vue&type=script&lang=js"
export * from "./PpnKeluaran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports